import { Component, OnInit } from '@angular/core';
import { Subscription } from 'rxjs';
import { AuthService } from 'src/app/core/authentication/auth.service';

@Component({
  selector: 'app-index',
  templateUrl: './index.component.html',
  styleUrls: ['./index.component.css']
})
export class IndexComponent implements OnInit {

  isAuthenticated: boolean;

  constructor(public authService: AuthService) { }

  ngOnInit() {
    this.authService.isLoggedInObs()
      .subscribe(flag => {
        this.isAuthenticated = flag;
    });
  }
}
